/** "2026-2027" → "SY 2026-2027"; "SY 2026-2027" stays as-is (school-year
 *  labels are free text, and some already carry the prefix). Empty → "". */
export function syLabel(label) {
  const t = (label || "").trim();
  if (!t) return "";
  return /^sy\b/i.test(t) ? t : `SY ${t}`;
}
